<template>
	<div style="width: 100%;" :style="{minHeight:'calc(100vh - ' + placeNavHeight + 'px)' }">
		<van-overlay :show="loading" style="background-color: rgb(0 0 0 / 0%);">
			<div style="display: flex;align-items: center;justify-content: center;width: 100%;height: 100%;">
				<van-loading color="#7d7d7d" type="spinner" />
			</div>
		</van-overlay>
		<!-- <div style="height: 30px;width: 1px;">
		</div> -->
		<div v-if="categoriesData" :style="equipment == 'pc'?{
		 		// width:equipment == 'pc'?'1280px':'100%'
		 		...boxStyleOne,
				minHeight:`calc(100vh - ${placeNavHeight + footerHeight}px)` 
		 	}:{
		 		width:'96%',
			minHeight:`calc(100vh - ${placeNavHeight + footerHeight}px)` 
		 	}" style="background-color: #fff;margin: auto;display: flex;height: 100%;">
			<div style="padding: 10px;width: 260px;" v-if="equipment == 'pc'">
				<div>
					<div style="font-weight: bold;">{{$t('h.classify')}}</div>
					<!-- {{selectCategoriesId}}
					:default-expanded-keys="[selectCategoriesId]" -->
					<el-tree node-key="url_name" 
						auto-expand-parent
						:default-expanded-keys="[selectCategoriesId]"
						style="margin-top: 20px;width: 260px;" class="custom-tree" 
						:data="categoriesData.all_categories" :props="defaultProps" @node-click="handleNodeClick">
						<template slot-scope="{ node, data }">
							<span class="custom-tree-node ">
								<span
									:style="{color:selectCategoriesId == data.url_name?'#635bff':'#626262',fontWeight:selectCategoriesId == data.url_name?'bold':''}">{{ data.name }}</span>
							</span>
						</template>
					</el-tree>
				</div>
				<div v-if="categoriesData && categoriesData.filter_data.price.select_min && show && categoriesData.filter_data.price.min < categoriesData.filter_data.price.max"
					style="padding-top: 40px;width: 250px;">
					<div style="font-weight: bold;">{{$t('h.price')}}</div>
					<div style="width: 100%;padding-top: 10px;">
						<el-slider v-if="categoriesData" @change="changePrice" input-size="mini" style="width: 250px;"
							:step="0.01" range :min="categoriesData.filter_data.price.min"
							:max="categoriesData.filter_data.price.max" v-model="search.price"></el-slider>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<div>{{categoriesData.filter_data.price.select_min}}</div>
						<div>{{categoriesData.filter_data.price.select_max}}</div>
					</div>
				</div>
				<div v-if="categoriesData">
					<div style="margin-top: 40px;" v-for="(item,index) in categoriesData.filter_data.attr">
						<div style="font-weight: bold;">
							{{item.name}}
						</div>
						<div style="margin: 8px;" v-for="(vItem,vIndex) in item.values" :key="vIndex">
							<el-checkbox @change="changeAttr($event,vItem,item)"
								v-model="vItem.selected">{{vItem.name}}</el-checkbox>
						</div>
					</div>
				</div>
			</div>
			<div style="padding: 10px;width: 100%;min-height: 100vh;">
				<div style="margin-top: 10px;display: flex;justify-content: space-between;">
					<div> </div>
					<div style="display: flex;align-items: center;">
						<div style="font-size: 14px;">
							1-{{search.per_page}} <span style="margin-left: 6px;">{{$t('h.allNum')}}:{{search.total}}
							</span>
						</div>
						<div v-if="categoriesData" style="margin-left: 10px;">
							<el-select @change="changePages" size="mini" style="width: 80px;" v-model="search.per_page">
								<el-option v-for="item in categoriesData.per_pages" :key="item" :label="item"
									:value="item">
								</el-option>
							</el-select>
						</div>
						<div style="margin-left: 10px;">
							<el-select @change="changeSort" :style="{
								width:equipment == 'pc'? '160px':'110px'
							}" size="mini" v-model="search.sort">
								<el-option v-for="(item,index) in options" :key="index" :label="item.name"
									:value="item.value">
								</el-option>
							</el-select>
						</div>
					</div>
				</div>
				<div style="display: flex;justify-content: center;width: 100%;"
					v-if="categoriesData && categoriesData.products.data.length == 0">
					<el-empty style="margin: auto;margin-top: 40px;" :description="$t('h.noData')"></el-empty>
				</div>
				<div v-if="categoriesData" :style="getLayStyle()" style="margin-top: 10px;">
					<div v-if="categoriesData.products.data.length > 0" @click="navTo(item)" :style="{
						boxShadow:selectItem &&  selectItem.id == item.id?' 0 0 10px 1px #999 ':'none',
						width: equipment == 'pc'?'300px':'46%',height: equipment == 'pc'?'auto':'auto',
						
					}" @mouseleave.stop.prevent="leaveGoods" @mouseenter.stop.prevent="entGood(item)"
						style="margin: auto;margin-top: 20px;" v-for="(item,index) in categoriesData.products.data"
						:key="index">
						<div style="position: relative;width: 100%;">
							<img v-lazy="item.images && item.images.length > 0?item.images[0]:''"
								style="width: 100%;aspect-ratio: 1/1;"
								:src="item.images && item.images.length > 0?item.images[0]:''" />
							<div v-if="selectItem &&  selectItem.id == item.id"
								style="height: 40px;background-color: #000;width: 100%;display: flex;color: #fff;position: absolute;bottom: 0px;align-items: center;justify-content: space-between;">
								<div @click.stop.prevent="addCart(item)"
									style="width: 80%;border-right: solid 1px #aaaaaa;height: 100%;display: flex;justify-content: center;align-items: center;">
									{{$t('h.addCart')}}
								</div>
								<div @click.stop.prevent="collect(item)"
									style="width: 20%;text-align: center;font-size: 18px;" v-if="item.in_wishlist == 0">
									<i style="color: #fff;" class="el-icon-star-off"></i>
								</div>
								<div @click.stop.prevent="collect(item)"
									style="width: 20%;text-align: center;font-size: 18px;" v-if="item.in_wishlist != 0">
									<i style="color: #fff;" class="el-icon-star-on"></i>
								</div>
							</div>
						</div>
						<div :style="{
						 	width:equipment == 'pc'?'300px':'100%'
						 }" style="text-align: center;margin-top: 10px;" class="tit">
							{{item.name_format}}
						</div>
						<div :style="{
							width:equipment == 'pc'?'300px':'100%',
							marginLeft: equipment == 'pc'?'0px':'0px'
						}" style="display: flex;justify-content: center;margin-top: 10px;">
							<div style="color: #635bff;">
								{{item.price_format}}
							</div>
							<div class="original-price" style="margin-bottom: 10px;margin-left: 10px;">
								{{item.origin_price_format}}
							</div>
						</div>
					</div>
				</div>
				<div style="height: 30px;width: 1px;">
				</div>
				<div :style="{
					width:equipment == 'pc'?'80%':'200px'
				}" v-if="categoriesData" style="display: flex;justify-content: center;margin-top: 20px;margin: auto;">
					<el-pagination @current-change="currentChange" layout="prev, pager, next" :total="search.total">
					</el-pagination>
				</div>
			</div>
			<el-dialog title="" :visible.sync="dialogVisible" :width="equipment == 'phone'?'90%':'60%'"
				:before-close="()=>{dialogVisible = false}">
				<div v-loading="iframeLogin">
					<iframe v-if="dialogVisible" id="iframe" style="width: 100%;min-height: 650px;" ref="iframe"
						src="/login?iframe=true" frameborder="0" scrolling="auto" @load="iframeLogin = false"></iframe>
				</div>
			</el-dialog>
		</div>
		<!-- <div style="height: 30px;width: 1px;">
		</div> -->
	</div>
</template>

<script>
	import {
		getCategoriesData,
		getAccountAddCarts,
		getAccountCollect
	} from '../../../api/all.js'
	export default {
		props: {
			footerHeight: {
				type: Number,
				default: 0
			},
			boxStyleTwo: {
				type: Object,
				default: () => {
					return {}
				}
			},
			boxStyleOne: {
				type: Object,
				default: () => {
					return {}
				}
			},
			placeNavHeight: {
				type: Number,
				default: 0
			},
			equipment: {
				type: String,
				default: "pc"
			},
			localPageData: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				changePriceApply: false,
				showLoading: true,
				show: true,
				options: [{
						name: this.$t('h.defaultTit'),
						value: ""
				
					},
					{
						name: this.$t('h.salesLowToHigh'),
						value: "sort=products.sales&order=asc"
				
					},
					{
						name: this.$t('h.salesHighToLow'),
						value: "sort=products.sales&order=desc"
				
				
					},
					{
						name: this.$t('h.nameAtoZ'),
						value: "sort=pd.name&order=asc"
				
					},
					{
						name: this.$t('h.nameZtoA'),
						value: "sort=pd.name&order=desc"
				
					},
					{
						name: this.$t('h.priceLowtoHeight'),
						value: "sort=products.sales&order=asc"
					},
					{
						name: this.$t('h.priceHeighttoLow'),
						value: "sort=product_skus.price&order=desc"
					}
				],
				iframeLogin: false,
				dialogVisible: false,
				isCollct: false,
				selectItem: null,
				search: {
					page: 1,
					total: 0,
					per_page: 10,
					price: 0,
					sort: "",
					prices: [],
					attrs: {

					}
				},
				selectCategoriesId: -1,
				loading: false,
				defaultProps: {
					children: 'children',
					label: 'name'
				},
				categoriesData: null
			}
		},
		
		async mounted() {
			

		},
		watch:{
			$route: {
				immediate: true,
				deep: true,
				handler: async function(to, from) {
					let that = this
					to.meta.id = to.params.id
					// console.log('$route', this.$route)
					// console.log('$route', this.$route.params.id)
					this.selectCategoriesId = to.params.id
					
					console.log('this.selectCategoriesId', this.selectCategoriesId)
					
					window.addEventListener('message', function(event) {
						console.log('eventeventevent', event)
						if (event && event.data.data.status == "success") {
							that.dialogVisible = false
							localStorage.setItem('address', JSON.stringify(event.data.data.data))
							// that.$message.success(event.data.data.message)
						}
					});
					await this.getData()
					this.$forceUpdate()
				}
			}
		},
		methods: {
			getLayStyle() {
				if (this.equipment == 'pc') {
					return 'display: grid;cursor: pointer;grid-template-columns: repeat(auto-fill, 300px); grid-gap: 40px 40px;justify-content: space-between;'
				} else {
					return {
						display: 'flex',
						flexWrap: 'wrap'
					}
				}
			},
			currentChange(e) {
				this.search.page = e
				this.getData()
			},
			changeSort(e) {
				console.log('e', e)
				this.getData()
			},
			changePages(e) {
				console.log('e', e)
				this.getData()
			},
			changeAttr(event, e, item) {
				console.log('event', event)
				console.log('e', e)
				console.log('item', item)
				if (event) {
					this.search.attrs[item.id + item.name] = `${item.id}:${e.id}`
				} else {
					delete this.search.attrs[item.id + item.name]
				}
				this.getData()
				console.log('this.search.attrs', this.search.attrs)
			},
			changePrice(e) {
				this.changePriceApply = true
				console.log('changePricee', e)
				this.search.prices = e
				this.search.price = e
				this.getData()
			},
			async collect(item) {
				console.log('item', item)
				try {
					console.log(this.sku)
					this.loading = true
					let wsid = this.$cookies.get("wsid")
					let data = await getAccountCollect({
						wsid,
						product_id: item.id
					})
					console.log(data)
					this.$message.success(data.data.message)
					this.loading = false
					if (item.in_wishlist == 0) {
						item.in_wishlist = 1
					} else {
						item.in_wishlist = 0
					}
					// this.isCollct = !this.isCollct
				} catch (e) {
					if (e.status == 401) {
						this.dialogVisible = true
						this.iframeLogin = true
					}
					this.loading = false
					console.log('e', e)

				}
			},
			async addCart(item) {
				try {
					console.log(this.sku)
					this.loading = true
					let wsid = this.$cookies.get("wsid")
					let data = await getAccountAddCarts({
						wsid,
						buy_now: false,
						sku_id: item.sku_id,
						quantity: 1
					})
					this.$message.success(data.data.message)
					this.loading = false
				} catch (e) {
					console.log('e', e)
					this.$message.error(e.response.data.message)
					this.loading = false
				}
			},
			navTo(item) {
				this.$router.push({
					path: '/products/' + item.url_name,

				})
			},
			leaveGoods() {
				this.selectItem = null
			},
			entGood(item) {
				this.selectItem = item
			},
			async getData() {
				if (!this.changePriceApply) {
					this.show = false
				}
				try {
					this.loading = true
					let obj = {
						url_name: this.selectCategoriesId
					}
					if (this.search.sort) {
						obj.sort = this.search.sort
					}
					if (this.search.prices.length > 0) {
						obj.price = this.search.prices.join('-')
					}
					if (this.search.per_page) {
						obj.per_page = this.search.per_page
					}

					if (this.search.attrs) {
						let str = ""
						for (let i in this.search.attrs) {
							console.log('i', i)
							console.log('this.search.attr123', this.search.attrs[i])
							if (str == '') {
								str = this.search.attrs[i]
							} else {
								str = str + '|' + this.search.attrs[i]
							}

						}
						if (str) {
							obj.attr = str
						}
					}
					if (this.search.page) {
						obj.page = this.search.page
					}
					console.log('obj.attr ', this.search.attrs)
					console.log('obj.attr ', obj)
					const data = await getCategoriesData({
						path: '/categories/' + this.selectCategoriesId,
						obj
					})
					// if(this.search.prices.length > 0) {
					// 	this.search.price = this.search.prices
					// }
					console.log('getCategoriesData', data)
					console.log('this.search.price', this.search.price)

					this.categoriesData = data.data.data
					this.search.per_page = this.categoriesData.products.per_page
					this.search.total = this.categoriesData.products.total
					console.log('getCategoriesData', this.categoriesData)

					this.$nextTick(() => {
						this.show = true
						this.changePriceApply = false
					})
					this.loading = false
				} catch (e) {
					this.loading = false
				}
			},
			handleNodeClick(node) {
				this.selectCategoriesId = node.url_name
				
				console.log('node.url_name', node.url_name)
				this.search = {
					page: 1,
					total: 0,
					per_page: 10,
					price: 0,
					sort: "",
					prices: [],
					attrs: {

					}
				}
				this.getData()
				// console.log(node.id)
				// this.$router.replace({
				// 	path:"/categories/" + node.id
				// })
				this.$emit('changePage', "/categories/" + node.url_name)
				this.$forceUpdate()
			},
			onChange() {

			}
		}
	}
</script>

<style scoped lang="scss">
	.custom-tree-node {
		width: 100%;
		overflow: hidden !important; // 溢出部分隐藏
		white-space: nowrap !important; //禁止自动换行
		text-overflow: ellipsis !important; // 使溢出部分以省略号显示
		display: block !important;
		font-size: 14px;
		color: #000;
		//鼠标悬停的备降色
	}

	.tit {
		display: -webkit-box;
		/* 设置为WebKit内核的弹性盒子模型 */
		-webkit-box-orient: vertical;
		/* 垂直排列 */
		-webkit-line-clamp: 1;
		/* 限制显示两行 */
		overflow: hidden;
		/* 隐藏超出范围的内容 */
		text-overflow: ellipsis;
	}

	.original-price {
		position: relative;
		text-decoration: line-through;
	}

	::v-deep .el-slider__button {
		width: 10px;
		height: 10px;
		border: solid 1px #635bff;
	}

	::v-deep .el-slider__bar {
		background-color: #635bff;
		height: 4px;
	}

	::v-deep .el-input__inner {
		border: solid 1px #635bff;
	}

	// el-input el-input--mini el-input--suffix is-focus
	::v-deep .el-select .el-input.is-focus .el-input__inner {
		border: solid 1px #635bff;
	}

	// ::v-deep .is-focus {
	// 	border: solid 1px #635bff;
	// }
	// ::v-deep .el-input--suffix{
	// 	border: solid 1px #635bff;
	// }
</style>